import { render, staticRenderFns } from "./niubi-detail.vue?vue&type=template&id=de54a398&scoped=true&"
import script from "./niubi-detail.vue?vue&type=script&lang=js&"
export * from "./niubi-detail.vue?vue&type=script&lang=js&"
import style0 from "./niubi-detail.scss?vue&type=style&index=0&id=de54a398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de54a398",
  null
  
)

export default component.exports